import {
  CAMPAIGN_METRICS,
  REP_STACK_METRICS,
  REP_TREND_METRICS,
  GATEWAY_METRICS,
} from '../componentKeys.js'

const identifiers = {
  key: 'revenuePerBillableHour',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Revenue / Billable Hour',
    prepend: '$',
  },
}

const keys = {
  componentKeys: [
    CAMPAIGN_METRICS,
    REP_STACK_METRICS,
    REP_TREND_METRICS,
    GATEWAY_METRICS,
  ],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'revenue' },
  divisor: { stat: 'billable_hours', convertTo: 'hours' },
}

const revenuePerBillableHour = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { revenuePerBillableHour }
